var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Heading } from 'shared/components/ui';
import { Outlet } from 'react-router-dom';
import { SubNav } from 'shared/components';
import { useFlagEnabled } from 'flagging/hooks';
import { useRbac } from 'shared/features/rbac';
import { Actions, Subjects } from 'constants/accessControlList';
import { SwitchSettingsAction } from './components';
import { useIsMySettings } from './hooks';
import { useAppointmentsAllAvailabilityRbac, useViewAs } from 'src/shared/hooks';
export * from './components';
export * from './Schedule';
export * from './Administrative';
/**
 * Index page for Settings
 */
var Settings = function () {
    var canI = useRbac().canI;
    var _a = useState(false), hideSubNav = _a[0], setHideSubNav = _a[1];
    var isMySettings = useIsMySettings();
    var allAvailability = useAppointmentsAllAvailabilityRbac().allAvailability;
    var canViewAllUsers = canI(Actions.View, Subjects.UsersAllUsers);
    var canViewProfile = canI(Actions.View, Subjects.UsersMyUser);
    var canViewSchedule = canI(Actions.View, Subjects.AppointmentsMyAppointments);
    var items = [];
    var showUsersFlagEnable = useFlagEnabled('SHOW_USERS_TAB_IN_SETTINGS');
    var showProfileFlagEnable = useFlagEnabled('SHOW_USER_PROFILE_TAB_IN_SETTINGS');
    var schedulingSettingsFlagEnabled = useFlagEnabled('SHOW_SCHEDULING_SETTINGS_ON_SIDEBAR');
    var administrativeFlagEnabled = useFlagEnabled('SHOW_ADMINISTRATIVE_TAB_IN_SETTINGS');
    var viewAsEnabled = useViewAs().viewAsEnabled;
    var headerCopy = isMySettings ? 'My Settings' : 'Administrative Settings';
    if (canViewAllUsers && showUsersFlagEnable && !isMySettings) {
        items.push({ text: 'Users', url: '/settings/users' });
    }
    if (canViewProfile && showProfileFlagEnable && isMySettings) {
        items.push({ text: 'Profile', url: '/settings/profile' });
    }
    if (schedulingSettingsFlagEnabled &&
        ((isMySettings && canViewSchedule) || (viewAsEnabled && allAvailability.canView))) {
        items.push({ text: 'Availability', url: '/settings/schedule' });
    }
    if (!isMySettings && administrativeFlagEnabled && canViewSchedule) {
        items.push({ text: 'Administrative', url: '/settings/administrative' });
    }
    /**
     * Render the component
     */
    return (_jsxs(_Fragment, { children: [_jsx(Heading, __assign({ size: "h2", "data-testid": "userProfile" }, { children: headerCopy })), !hideSubNav && _jsx(SubNav, { items: items, mt: 2, mb: 4, actions: _jsx(SwitchSettingsAction, {}) }), _jsx(React.Suspense, __assign({ fallback: _jsx("div", { children: "Loading..." }) }, { children: _jsx(Outlet, { context: { setHideSubNav: setHideSubNav } }) }))] }));
};
export default Settings;
